import clsx from "clsx";

import HourCount from "~/modules/timeTracking/components/components/Day/components/HourCount/HourCount";
import type {
	TimeTrackingBarThemes,
} from "~/modules/timeTracking/components/components/Day/components/TimeTrackingBar/timeTrackingBarVariants.ts";
import {
	timeTrackingBarVariants,
} from "~/modules/timeTracking/components/components/Day/components/TimeTrackingBar/timeTrackingBarVariants.ts";

interface Props extends Omit<React.HTMLProps<HTMLDivElement>, "size"> {
	theme?: TimeTrackingBarThemes;
	hours?: string | number;
	size?: "default" | "sm";
	className?: string;
	width?: number;
	onClick?: () => void;
}

const TimeTrackingBar = ({
	children,
	theme,
	hours,
	size,
	className,
	width = 100,
	onClick,
}: Props) => {
	const { barWrapper, barInner } = timeTrackingBarVariants({ theme, size });

	return (

		<div
			className={clsx(
				barWrapper(),
				undefined !== onClick && "cursor-pointer",
				className,
			)}
			style={{
				width: `${width}%`,
			}}
			onClick={onClick}
		>
			<div className={barInner()}>{children}</div>
			{hours && width > 5 && <HourCount theme={theme} size={size}>{hours}</HourCount>}
		</div>
	);
};

export default TimeTrackingBar;
